import React from 'react';
import { BeatLoader } from 'components/Reusable/Loaders';
import Sidemenu from 'components/Landing/sidemenu';
import DialogWrapper from 'components/contexts/dialogs/toast';
import LoaderWrapper from 'components/contexts/loader';
import styles from './homeLayout.module.scss';
// import { userContext } from 'components/contexts/auth/auth.context';
// import { Link } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';
// import { environment } from 'env/environment';

export default function HomeLayout({ children }) {
  // const { user } = React.useContext(userContext);
  // const {
  //   i18n: { language }
  // } = useTranslation();
  // const bareLang = language.split('-')[0];

  return (
    <>
      <DialogWrapper>
        <div className={styles.mainWrapper}>
          <Sidemenu />
          <div className={styles.page_container}>
            {/* {user?.has_eoy_stats && (
              <Link
                rel="noreferrer"
                target="_blank"
                to={`https://2025inmusic.anghami.com/artist/${user.d_artist.id}`}
              >
                <img
                  src={`${environment.creators_assets_cdn}/images/EOY25BannerArtists-${bareLang}-2025.png`}
                  className="w-100"
                  alt="artist eoy"
                />
              </Link>
            )} */}
            <LoaderWrapper loaderComponent={<BeatLoader />}>{children}</LoaderWrapper>
          </div>
        </div>
      </DialogWrapper>
    </>
  );
}
